import classNames from 'classnames';

const ListItem = ({
  text,
  value,
  selected = false,
  onClick = () => {},
}: {
  text: string;
  value: string | number;
  selected?: boolean;
  onClick?: (value: string | number) => void;
}) => {
  const classes = classNames({
    'list-item': true,
    'list-item--selected': !!selected,
  });

  return (
    <li key={`item-${value}`} className={classes}>
      <button type="button" onClick={() => onClick(value)}>
        {text}
      </button>
    </li>
  );
};

export default ListItem;
